//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Workouts4AboveTheFold from '~/components/workouts/Workouts4_AboveTheFold.vue';
import Workouts4Banner from '~/components/workouts/Workouts4_Banner.vue';
import Workouts4TrainerBlocks from '~/components/workouts/Workouts4_TrainerBlocks.vue';
import Workouts4Format from '~/components/workouts/Workouts4_Format.vue';
import Workouts4Compare from '~/components/workouts/Workouts4_Compare.vue';
import Workouts4Banner2 from '~/components/workouts/Workouts4_Banner2.vue';
import Workouts4YouVsYou from '~/components/workouts/Workouts4_YouVsYou.vue';
import Workouts4Time from '~/components/workouts/Workouts4_Time.vue';
import Workouts4CTA from '~/components/workouts/Workouts4_CTA.vue';
import { metaData } from '~/configuration/metaData';

export default {
  name: 'Workouts',
  head: {
    ...metaData.whyItWorks,
  },
  components: {
    Workouts4AboveTheFold,
    Workouts4Banner,
    Workouts4TrainerBlocks,
    Workouts4Format,
    Workouts4Compare,
    Workouts4Banner2,
    Workouts4YouVsYou,
    Workouts4Time,
    Workouts4CTA,
  },
};
